import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import createStore from './store'

import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap/dist/js/bootstrap.bundle.min.js'
// import 'bootstrap-vue/dist/bootstrap-vue.css'
// import 'bootstrap/dist/js/bootstrap.bundle'
import './styles/index.scss'

createApp(App).use(createStore).use(router).mount('#app')
